import React from "react";
import log from "../utility/log";
import ga from 'react-ga4';

let withTracker;

if (process.env.BUILD_TARGET !== "server") {
  let gaInitialized = false;
  let pendingPage: string | null = null;

  const initGA = () => {
    if (!gaInitialized) {
      ga.initialize("G-EFWCHJGC1X");
      gaInitialized = true;
    }
  };

  const sendPageView = (page: string) => {
    ga.set({ page });
    ga.send("pageview");
    const env = `https://www.teraz.sk/essentials/scripts/environment.php?tplp=teraz&t=teraz&ref=${encodeURIComponent(page)}`;
    fetch(env).catch((e) => console.error("enviroment fetch failed", e));
  };

  const trackPage = (page: string) => {
    log.debug("pageview", page);
    if (!gaInitialized) {
      pendingPage = page;
      return;
    }
    sendPageView(page);
  };

  // For returning visitors who already accepted in a previous session
  const alreadyAccepted = document.cookie.replace(
    /(?:(?:^|.*;\s*)cookiePolicyConfirmed\s*=\s*([^;]*).*$)|^.*$/,
    "$1"
  ) === "true";

  if (alreadyAccepted) {
    initGA();
  }

  // Initialize GA and flush any queued page view once analytics consent is granted
  document.addEventListener("changeApproves", function(e: any) {
    const approves = e.detail;
    if (approves.approvedCookie) {
      initGA();
      if (pendingPage) {
        sendPageView(pendingPage);
        pendingPage = null;
      }
    }
  });

  withTracker = (WrappedComponent) => {
    const HOC = (props) => {
      const page = props.location.pathname + props.location.search;
      trackPage(page);
      return <WrappedComponent {...props} />;
    };

    return HOC;
  };
} else {
  withTracker = (a) => a;
}

export default withTracker;
